import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  LoadRollupGrouping,
  ResetRollupGrouping,
} from './../../../../ng2/store/actions/rollup-grouping-actions/rollup-grouping-actions';
import { IRollupGroupingPayload } from './../../../../ng2/store/actions/rollup-grouping-actions/rollup-grouping-actions';
import {
  getRollupGroupingData,
  getRollupGroupingLoadedStatus,
} from './../../../../ng2/store/selectors/rollup-grouping-selectors/rollup-grouping-selectors';

@Injectable()
export class RollupGroupingResolver {
  resolveRollupGroupingData$(store: Store<any>, payload: IRollupGroupingPayload): Promise<Observable<any>> {
    const destroy$: Subject<boolean> = new Subject<boolean>();

    store.dispatch(new ResetRollupGrouping());

    return new Promise(resolve => {
      store
        .select(getRollupGroupingLoadedStatus)
        .pipe(takeUntil(destroy$))
        .subscribe((loaded: boolean) => {
          if (!loaded) store.dispatch(new LoadRollupGrouping(payload));
          if (loaded) {
            const groupingData$ = store.select(getRollupGroupingData);
            destroy$.next(true);
            destroy$.unsubscribe();
            resolve(groupingData$);
          }
        });
    });
  }
}
